import React from "react";
import clsx from "clsx";

function EmbedHtml({ body, number_of_rows }) {
    return (
        <div
            className={clsx({
                container: number_of_rows === 1,
                "w-full": number_of_rows !== 1,
            })}
        >
            <div className="row">
                <div className="col-12">
                    <div className="responsive-iframe" dangerouslySetInnerHTML={{ __html: body }} />
                </div>
            </div>
        </div>
    );
}

export default EmbedHtml;
